export default "__VITE_ASSET__wvrKh5TE__$_?component__"